var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card-actions",
    {
      attrs: {
        title: _vm.$t("Cobertura de custo"),
        "no-actions": "",
        "show-loading": _vm.loading,
      },
    },
    [
      _c(
        "b-row",
        { staticClass: "mb-1" },
        [
          _c(
            "b-col",
            { attrs: { md: "3" } },
            [
              _c("FormulateInput", {
                attrs: {
                  id: "coverage-sale-value",
                  label: _vm.$t("Valor de referência"),
                  type: "text-number",
                  currency: "R$",
                  precision: 2,
                },
                model: {
                  value: _vm.localSaleValue,
                  callback: function ($$v) {
                    _vm.localSaleValue = $$v
                  },
                  expression: "localSaleValue",
                },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            { staticClass: "d-flex align-items-end pb-1", attrs: { md: "3" } },
            [
              _c("e-button", {
                attrs: {
                  text: _vm.$t("Calcular"),
                  variant: "primary",
                  busy: _vm.loading,
                },
                on: { click: _vm.loadCoverage },
              }),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.applySurcharge
        ? _c(
            "b-alert",
            { staticClass: "p-1", attrs: { show: "", variant: "warning" } },
            [
              _c("feather-icon", { attrs: { icon: "AlertTriangleIcon" } }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "Esta política não repassa acréscimo ao cliente. A margem abaixo é negativa por definição, e representa o custo que a Loja absorve em cada faixa."
                    )
                  ) +
                  " "
              ),
            ],
            1
          )
        : _vm._e(),
      _c("b-table", {
        staticClass: "bordered",
        attrs: {
          "show-empty": "",
          responsive: "",
          striped: "",
          small: "",
          "empty-text": _vm.$t("Informe um valor e clique em Calcular"),
          fields: _vm.fields,
          items: _vm.coverageLines,
        },
        scopedSlots: _vm._u([
          {
            key: "cell(installments)",
            fn: function (row) {
              return [
                _vm._v(" " + _vm._s(row.item.installments) + "x "),
                row.item.usesCashOperationCost
                  ? _c(
                      "b-badge",
                      {
                        staticClass: "ml-50",
                        attrs: { variant: "light-info" },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("à vista")) + " ")]
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(coverageMarginPoints)",
            fn: function (row) {
              return [
                _c(
                  "span",
                  {
                    class: row.item.hasNegativeCoverage
                      ? "text-danger font-weight-bold"
                      : "text-success",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.formatPercent(row.item.coverageMarginPoints)
                        ) +
                        " "
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "cell(coverageMarginValue)",
            fn: function (row) {
              return [
                _c(
                  "span",
                  {
                    class: row.item.hasNegativeCoverage
                      ? "text-danger font-weight-bold"
                      : "text-success",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("currency")(row.item.coverageMarginValue)
                        ) +
                        " "
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "cell(detail)",
            fn: function (row) {
              return [
                _c("e-button", {
                  attrs: {
                    icon: row.detailsShowing ? "chevron-up" : "chevron-down",
                    variant: "outline-primary",
                    size: "sm",
                  },
                  on: { click: row.toggleDetails },
                }),
              ]
            },
          },
          {
            key: "row-details",
            fn: function (row) {
              return [
                _c("b-table", {
                  staticClass: "bordered m-0",
                  attrs: {
                    small: "",
                    striped: "",
                    fields: _vm.detailFields,
                    items: row.item.installments_Detail || [],
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }